import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/384b93b1c6b709649e2997bc3ca9e948.jpg"
            alt="Hero Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="space-y-8">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white leading-tight">
              <span className="block">TRUSTED GUIDES</span>
              <span className="block text-6xl sm:text-7xl lg:text-8xl bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent">
                GIVEAWAYS &amp; UPDATES
              </span>
            </h1>
            <p className="text-xl sm:text-2xl text-gray-200 max-w-3xl mx-auto font-medium">
              Your Safe Source for Gaming Info &amp; Tech Knowledge
            </p>
            <Link
              to="/free-fire-giveaway"
              className="inline-flex items-center space-x-3 bg-gradient-to-r from-orange-500 to-red-500 text-white px-10 py-4 rounded-full font-bold text-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              <span>EXPLORE GIVEAWAYS</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>

            {/* Trust Badges */}
            <div className="flex flex-wrap items-center justify-center gap-6 pt-8">
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
                <i className="ri-shield-check-line text-green-400 text-xl"></i>
                <span className="text-white text-sm font-semibold whitespace-nowrap">AdSense Safe</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
                <i className="ri-lock-line text-blue-400 text-xl"></i>
                <span className="text-white text-sm font-semibold whitespace-nowrap">No Password Required</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
                <i className="ri-gift-line text-yellow-400 text-xl"></i>
                <span className="text-white text-sm font-semibold whitespace-nowrap">100% Free Info</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Categories */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-2">Featured Categories</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-orange-500 to-red-500 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Free Fire Card */}
            <Link
              to="/free-fire-giveaway"
              className="group relative bg-gradient-to-br from-purple-900 via-purple-800 to-black rounded-3xl p-8 overflow-hidden hover:shadow-2xl transition-all duration-500 hover:scale-105"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="relative z-10">
                <div className="w-14 h-14 flex items-center justify-center bg-orange-500 rounded-full mb-6">
                  <i className="ri-fire-fill text-white text-2xl"></i>
                </div>
                <h3 className="text-3xl font-bold text-white mb-4">Free Fire Diamond Giveaway</h3>
                <p className="text-gray-300 mb-6 leading-relaxed">
                  Learn how to participate safely in Free Fire diamond giveaways. Complete guide with safety tips and entry process.
                </p>
                <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm text-white px-6 py-3 rounded-full font-semibold group-hover:bg-white/20 transition-all duration-300 whitespace-nowrap">
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>

            {/* BGMI Card */}
            <Link
              to="/bgmi-giveaway"
              className="group relative bg-gradient-to-br from-teal-900 via-teal-800 to-black rounded-3xl p-8 overflow-hidden hover:shadow-2xl transition-all duration-500 hover:scale-105"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-teal-600/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="relative z-10">
                <div className="w-14 h-14 flex items-center justify-center bg-cyan-500 rounded-full mb-6">
                  <i className="ri-gamepad-fill text-white text-2xl"></i>
                </div>
                <h3 className="text-3xl font-bold text-white mb-4">BGMI UC Giveaway</h3>
                <p className="text-gray-300 mb-6 leading-relaxed">
                  Discover safe ways to participate in BGMI UC giveaways. Step-by-step guide with important safety information.
                </p>
                <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm text-white px-6 py-3 rounded-full font-semibold group-hover:bg-white/20 transition-all duration-300 whitespace-nowrap">
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>

            {/* Tech Card */}
            <Link
              to="/tech-blog"
              className="group relative bg-gradient-to-br from-blue-50 to-white rounded-3xl p-8 overflow-hidden hover:shadow-2xl transition-all duration-500 hover:scale-105 border-2 border-blue-100"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-blue-100/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="relative z-10">
                <div className="w-14 h-14 flex items-center justify-center bg-blue-500 rounded-full mb-6">
                  <i className="ri-lightbulb-flash-fill text-white text-2xl"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">Tech Guides &amp; Tips</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Explore helpful tech tutorials, app guides, and online safety tips. Stay updated with the latest technology trends.
                </p>
                <div className="inline-flex items-center space-x-2 bg-blue-500 text-white px-6 py-3 rounded-full font-semibold group-hover:bg-blue-600 transition-all duration-300 whitespace-nowrap">
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose InfoDrop */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Why Trust InfoDrop?
              </h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">100% Safe Information</h3>
                    <p className="text-gray-600 leading-relaxed">
                      We never ask for passwords or personal gaming credentials. Your account security is our priority.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">AdSense Compliant</h3>
                    <p className="text-gray-600 leading-relaxed">
                      All content follows Google AdSense policies. No misleading claims or fake promises.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Educational Content</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Learn about giveaways, tech tips, and online safety through our informative guides.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20smartphone%20displaying%20colorful%20gaming%20and%20technology%20website%20interface%20with%20clean%20design%20professional%20mobile%20app%20mockup%20on%20gradient%20background%20showing%20trust%20and%20security%20elements&width=800&height=900&seq=trust001&orientation=portrait"
                  alt="InfoDrop Mobile Interface"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Updates */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-12">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-2">Latest Giveaway Updates</h2>
              <div className="w-20 h-1 bg-gradient-to-r from-orange-500 to-red-500 rounded-full"></div>
            </div>
            <Link
              to="/free-fire-giveaway"
              className="hidden sm:inline-flex items-center space-x-2 text-orange-500 font-semibold hover:text-orange-600 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              <span>View All</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                title: 'Free Fire Diamond Giveaway - January 2026',
                date: 'Jan 15, 2026',
                image: 'https://readdy.ai/api/search-image?query=free%20fire%20game%20diamonds%20crystals%20glowing%20on%20simple%20dark%20purple%20gradient%20background%20mobile%20gaming%20rewards%20concept%20clean%20minimal%20style&width=400&height=300&seq=ff001&orientation=landscape',
                link: '/free-fire-giveaway',
              },
              {
                title: 'BGMI UC Giveaway - New Year Special',
                date: 'Jan 10, 2026',
                image: 'https://readdy.ai/api/search-image?query=bgmi%20battlegrounds%20mobile%20india%20uc%20currency%20coins%20on%20simple%20teal%20gradient%20background%20gaming%20rewards%20minimal%20clean%20design&width=400&height=300&seq=bgmi001&orientation=landscape',
                link: '/bgmi-giveaway',
              },
              {
                title: 'How to Stay Safe in Online Giveaways',
                date: 'Jan 8, 2026',
                image: 'https://readdy.ai/api/search-image?query=digital%20security%20shield%20protection%20icon%20on%20simple%20blue%20gradient%20background%20cyber%20safety%20concept%20clean%20minimal%20modern%20design&width=400&height=300&seq=safe001&orientation=landscape',
                link: '/tech-blog',
              },
              {
                title: 'Top Gaming Apps for Android 2026',
                date: 'Jan 5, 2026',
                image: 'https://readdy.ai/api/search-image?query=modern%20smartphone%20with%20gaming%20apps%20icons%20on%20simple%20gradient%20background%20mobile%20gaming%20technology%20clean%20minimal%20professional%20design&width=400&height=300&seq=apps001&orientation=landscape',
                link: '/tech-blog',
              },
            ].map((update, index) => (
              <Link
                key={index}
                to={update.link}
                className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                <div className="w-full h-48">
                  <img
                    src={update.image}
                    alt={update.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <p className="text-xs text-orange-500 font-semibold mb-2">{update.date}</p>
                  <h3 className="text-base font-bold text-gray-900 line-clamp-2 group-hover:text-orange-500 transition-colors duration-300">
                    {update.title}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
